module.exports = __webpack_public_path__ + "media/images/landing/home/biometric-fbc423918b8f7283b1bfe2be606d5b25.png";